import { loginAPI } from "../../apis/LoginAPI.jsx";
import { utils } from "../../utils/Utils.jsx";

export default class SideBarService {
  logout(token, redirectCallback, props, setConfig, setToken) {
    console.log("token", token);
    loginAPI
      .logout(token)
      .then((response) => {
        console.log("logout success", response);

        utils.clearSession(props, setConfig, setToken);
      })
      .catch((error) => {
        //Failure
        console.log("logout error", error);

        utils.clearSession(props, setConfig, setToken);
      });
  }
}
